import { render, staticRenderFns } from "./TableBlueLabelAmount.vue?vue&type=template&id=059ed3aa&scoped=true&"
import script from "./TableBlueLabelAmount.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelAmount.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelAmount.vue?vue&type=style&index=0&id=059ed3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ed3aa",
  null
  
)

export default component.exports